const configurationValuesReducer = (state = {}, action) => {
	if(action.type === 'SET_CONFIGURATION_VALUES') {
			return action.payload
		} else {
			return state
		}	
}

export default configurationValuesReducer;